export const SEEDS_LABELS = {
	URLS_LIST_TITLE: 'Urls list',
	SEEDS_LIST_TITLE: 'Seeds list',
	SECTION_ARIA_LABEL: 'Seeds list',
	CLEAR_LIST: 'Clear list',
	CONFIRM_REMOVING_URLS: 'Confirm removing urls',
	CONFIRM_REMOVING_ALL_URLS: 'Confirm removing all urls',
	DISABLED_REASON: 'Check URLs to enable this button',
	DUPLICATE_URL: 'This URL is already in the list',
	DUPLICATE_SEED: 'This seed is already in the list',
	IMPORT_VALID_HEADER: 'urls',
	MORE_INFO_LIST:
		'List mode allows you to skip the discovery phase (crawling) and provide a static list of URLs for the system to scan.',
	MORE_INFO_CRAWL: 'Seed URLs are the entry point for the crawler.'
} as const;
